import React from 'react'

const MailIcon = (props) => (
    <svg {...props} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18" r="18" fill="#6B8A6E"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M11.1753 13.1522C11.1194 13.1134 11.0836 13.0588 11.0678 12.9998H25.6769C25.6614 13.0589 25.6257 13.1138 25.5699 13.153L19.0357 17.7042C18.6462 17.9759 18.1283 17.9767 17.738 17.7057L11.1753 13.1522ZM17.4773 19.1183L10.1303 14.0206C10.0459 14.1816 10 14.3628 10 14.55V22.2184C10 22.8356 10.4996 23.3359 11.1168 23.3359H25.2899C25.907 23.3359 26.4067 22.8356 26.4067 22.2184V14.5515C26.4067 14.3644 26.3608 14.1833 26.2766 14.0224L18.9629 19.1166C18.517 19.4277 17.9241 19.4285 17.4773 19.1183Z" fill="white"/>
    </svg>
)

export default MailIcon;